import { MonitoringItem } from './types';

export const MOCK_MONITORING_DATA: MonitoringItem[] = [
  {
    id: 1,
    name: 'Albendazol - Sul e Sudeste',
    type: 'Tipo do monitoramento',
    ativo: true,
    isVarejo: true,
    details: {
      productName: 'Albendazol 400mg 1 Comprimido Mastigável Medley Genérico',
      competitorsCount: 3,
      competitorProducts: [
        { ean: '7898148295210', name: 'Albendazol Comprimido 400mg, Caixa Com 1 Comprimido Mastigável' },
        { ean: '7898148001654', name: 'Parasin Albendazol 400mg 1 Comprimido Mastigável' },
        { ean: '7896523215747', name: 'Albendazol 400mg CPD 1 GN' },
      ],
      allProducts: [
        { ean: '7898148295210', name: 'Albendazol Comprimido 400mg, Caixa Com 1 Comprimido Mastigável' },
        { ean: '7898148001654', name: 'Parasin Albendazol 400mg 1 Comprimido Mastigável' },
        { ean: '7896523215747', name: 'Albendazol 400mg CPD 1 GN' },
      ],
      tipoComparacao: 'PRODUTO',
      categorias: [],
      secoes: [],
      networksCount: 2,
      citiesCount: 3,
      cities: ['Porto Alegre', 'Curitiba', 'São Paulo'],
      tipoLocal: 'Cidade',
      period: 'Últimas 4 semanas',
    },
  },
  {
    id: 2,
    name: 'Albendazol - Sul e Sudeste',
    type: 'Tipo do monitoramento',
    ativo: true,
    isVarejo: true,
    details: {
      productName: '7897322709482 - Polivitamínico VitaMedley Mulher A-Z 30 cápsulas',
      competitorsCount: 100,
      competitorProducts: [
        { ean: '7898430192913', name: 'D Prev 7000 U.I.' },
        { ean: '10004692', name: 'D3 7.000 U.I Althaia' },
        { ean: '7896006200901', name: 'D3 7.000 U.I Neo Química' },
        { ean: '7898430192914', name: 'D Prev 7000 U.I.' },
        { ean: '10004693', name: 'D3 7.000 U.I Althaia' },
        { ean: '7896006200902', name: 'D3 7.000 U.I Neo Química' },
        { ean: '7898430192915', name: 'D Prev 7000 U.I.' },
        { ean: '10004694', name: 'D3 7.000 U.I Althaia' },
        { ean: '7896006200903', name: 'D3 7.000 U.I Neo Química.' },
        { ean: '7898430192916', name: 'D Prev 7000 U.I.' },
        { ean: '7891058010201', name: 'Polivitamínico Centrum Mulher A-Z 30 comprimidos' },
        { ean: '7891045032841', name: 'Vitaminas Lavitan A-Z Mulher 60 cápsulas' },
      ],
      allProducts: [
        { ean: '7898430192913', name: 'D Prev 7000 U.I.' },
        { ean: '10004692', name: 'D3 7.000 U.I Althaia' },
        { ean: '7896006200901', name: 'D3 7.000 U.I Neo Química' },
        { ean: '7898430192914', name: 'D Prev 7000 U.I.' },
        { ean: '10004693', name: 'D3 7.000 U.I Althaia' },
        { ean: '7896006200902', name: 'D3 7.000 U.I Neo Química' },
        { ean: '7898430192915', name: 'D Prev 7000 U.I.' },
        { ean: '10004694', name: 'D3 7.000 U.I Althaia' },
        { ean: '7896006200903', name: 'D3 7.000 U.I Neo Química.' },
        { ean: '7898430192916', name: 'D Prev 7000 U.I.' },
        { ean: '7891058010201', name: 'Polivitamínico Centrum Mulher A-Z 30 comprimidos' },
        { ean: '7891045032841', name: 'Vitaminas Lavitan A-Z Mulher 60 cápsulas' },
      ],
      tipoComparacao: 'PRODUTO',
      categorias: [],
      secoes: [],
      networksCount: 2,
      citiesCount: 3,
      cities: ['Porto Alegre', 'Curitiba', 'São Paulo'],
      tipoLocal: 'Cidade',
      period: 'Últimas 4 semanas',
    },
  },
  {
    id: 3,
    name: 'Vitaminas - Região Norte',
    type: 'Tipo do monitoramento',
    ativo: true,
    isVarejo: true,
    details: {
      productName: 'Vitamina C 1g Efervescente 10 comprimidos',
      competitorsCount: 45,
      competitorProducts: [{ ean: '7891058001117', name: 'Vitamina C Cebion 1g Efervescente 10 comprimidos' }],
      allProducts: [{ ean: '7891058001117', name: 'Vitamina C Cebion 1g Efervescente 10 comprimidos' }],
      tipoComparacao: 'PRODUTO',
      categorias: [],
      secoes: [],
      networksCount: 1,
      citiesCount: 5,
      cities: ['Belém', 'Manaus', 'Macapá', 'Boa Vista', 'Porto Velho'],
      tipoLocal: 'Cidade',
      period: 'Últimas 4 semanas',
    },
  },
  {
    id: 4,
    name: 'Analgésicos - Centro-Oeste',
    type: 'Tipo do monitoramento',
    ativo: false,
    isVarejo: false,
    details: {
      productName: 'Dipirona Sódica 500mg 30 comprimidos',
      competitorsCount: 78,
      competitorProducts: [
        { ean: '7896004800417', name: 'Dipirona Monoidratada 500mg 30 comprimidos' },
        { ean: '7891058002817', name: 'Novalgina 500mg 30 comprimidos' },
      ],
      allProducts: [
        { ean: '7896004800417', name: 'Dipirona Monoidratada 500mg 30 comprimidos' },
        { ean: '7891058002817', name: 'Novalgina 500mg 30 comprimidos' },
      ],
      tipoComparacao: 'PRODUTO',
      categorias: [],
      secoes: [],
      networksCount: 3,
      citiesCount: 4,
      cities: [],
      tipoLocal: 'Todo o território',
      period: 'Últimas 4 semanas',
    },
  },
];
